import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Checkbox, Heading, Paragraph, ValidationMessage } from '@digdir/designsystemet-react';

import { OppvarmingFormData } from '../../../types';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';

import { BiokaminCheckbox } from './biokaminCheckbox';
import { BiokaminMedVannkappeCheckbox } from './biokaminMedVankappeCheckbox';
import { BiokjelCheckbox } from './biokjelCheckbox';

export const Bioenergi = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { validateOppvarmingSelection } = useOppvarmingValidation();
  const { t } = useTranslation();

  // Common error and message for the whole group of checkboxes - we use the one from kamin and show it once
  const bioenergiError = formState.errors?.bioenergi?.value?.kamin?.selected?.message;
  const selectionError = formState.errors?.bioenergi?.selected;
  const bioenergiSelected = watch('bioenergi.selected');

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!selectionError}
        label={t('form.oppvarming.bioenergi.label')}
        {...register('bioenergi.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {bioenergiSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('form.oppvarming.bioenergi.heading')}
            </Heading>
            <Paragraph>{t('form.oppvarming.bioenergi.description')}</Paragraph>
          </LeftBorderedContent>

          <BiokaminCheckbox />
          <BiokaminMedVannkappeCheckbox />
          <BiokjelCheckbox />
          {bioenergiError && (
            <LeftBorderedContent>
              <ValidationMessage>{bioenergiError}</ValidationMessage>
            </LeftBorderedContent>
          )}
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
